import Constants from "expo-constants";

export const EUREKA_CLIENT_ID =
  Constants.expoConfig?.extra?.eurekaClientId ?? "roam";

export const EUREKA_AUTHORIZATION_ENDPOINT =
  Constants.expoConfig?.extra?.eurekaAuthorizationEndpoint ??
  "http://192.168.59.212:4003/oauth2/authorize";

export const EUREKA_TOKEN_ENDPOINT =
  Constants.expoConfig?.extra?.eurekaTokenEndpoint ??
  "http://192.168.59.212:3038/oauth2/token";

export const EUREKA_SCOPES = ["roam"];

export const EUREKA_REDIRECT_PATH =
  Constants.expoConfig?.extra?.eurekaRedirectPath ?? "/auth/callback";

export const PKCE_VERIFIER_KEY_PREFIX = "eureka_pkce_verifier_"; // + state
